import { ReactElement } from "react";

import { MFA_FACTOR_COPY } from "../../constants/factorCopy";

import { Factor } from "types/factor/factor";

import PhoneNumberInput from "../phoneNumberInput/PhoneNumberInput";
import TotpSetup from "../totpSetup/TotpSetup";
import AuthCodeInput from "../authCodeInput/AuthCodeInput";
import WebAuthnSetup from "../webAuthnSetup/WebAuthnSetup";

import styles from "./factor-setup.module.css";

const FactorSetup = ({
  factor,
  onCancel,
  onSuccess,
  isCancellingAuthEnrollment = false,
}: {
  factor: Factor;
  onCancel: () => void;
  onSuccess?: () => void;
  isCancellingAuthEnrollment?: boolean;
}): ReactElement => {
  const copy = MFA_FACTOR_COPY[factor.key];

  if (factor.flags.isPasskeyFactor) {
    return (
      <div className={styles.factorSetup}>
        <div className={styles.setupDescription}>{copy.setUpHeading}</div>
        <WebAuthnSetup
          factor={factor}
          onCancel={onCancel}
          onSuccess={onSuccess}
        />
      </div>
    );
  }

  return (
    <div className={styles.factorSetup}>
      <div className={styles.setupDescription}>{copy.setUpHeading}</div>

      <div>
        <div className={styles.stepLabel}>Step 1</div>
        {factor.flags.isPhoneFactor && <PhoneNumberInput factor={factor} />}

        {factor.flags.isTotpFactor && <TotpSetup factor={factor} />}
      </div>

      <div>
        <div className={styles.stepLabel}>Step 2</div>
        <AuthCodeInput
          factor={factor}
          onCancel={onCancel}
          isCancellingAuthEnrollment={isCancellingAuthEnrollment}
        />
      </div>
    </div>
  );
};

export default FactorSetup;
